export default __webpack_public_path__ + "static/media/incident.45a7528c.svg";